export const bands = [
  {
    id: "foxfight",
    name: "Foxfight",
    yearsActive: "2007,2020-2022",
    profile: "ff-profile.png",
    bio: "In 2007 a few us decided to re-form and play some songs I had been working on under the name Tiger Uppercut. " +
      "In the end scheduling challenges along with other band committments caused some conflict so we gave up before playing a gig sadly." +
      "Fast forward to the lockdown caused by Covid and we agreed to use the live recordings of the unfinished songs to record a mini-album" +
      "remotely using our home recording setups. I'm really pleased with the end result and I learned a lot about home recording. " +
      "All the songs were mixed by Aiden and I created the cover art using a photo I took of the Deadvlei in Namibia. " +
      "We also released a remaster of our Poor Me EP from 1998.",
    albums: [
      {
        name: "Losing All Colours",
        releaseDate: "4/6/2021",
        cover: "/img/music/ff-lac-cover_sm.jpeg",
        tracks: [
          "Just Friends",
          "Ask Yourself",
          "You Never Hurt",
          "Emotive Motive",
          "Secret Weapon",
          "On A Roll",
          "Something To Someone"
        ]
      },
      {
        name: "Poor Me",
        releaseDate: "12/9/2022",
        cover: "/img/music/ff-poorme_sm.png",
        tracks: [
          "Poor Me",
          "Living In This",
          "Drowners"
        ]
      }
    ],
    members: [
      { name: "Phil", role: "Vocals/Guitar/Bass" },
      { name: "Aiden", role: "Guitar" },
      { name: "Ricky", role: "Drums" }
    ],
    soundcloud: "foxfightmusic",
    spotify: "0armYw2C2SwUq9FQ7qM2A9",
    bandcamp: "foxfightmusic"
  },
  {
    id: "messagefromtheoppressor",
    name: "Message From The Oppressor",
    yearsActive: "2021-2022",
    profile: "mfto-profile.jpeg",
    bio: "Born from mutual appreciation and regular attendence at the Arctangent festival we decided to collaborate on some demos Simon " +
      "had been working on. It was a fun experience, particulary writing vocals and guitars for someone else's chord progressions and  " +
      "for a slower tempo than I am used to. The band name is a tongue-in-cheek attempt to sound as 'Arctangent' as possible.",
    albums: [
      {
        name: "Triptych",
        releaseDate: "15/8/2022",
        cover: "/img/music/mfto-triptych_sm.jpg",
        tracks: [
          "Hireath",
          "Tabula Rasa",
          "Severance"
        ]
      }
    ],
    members: [
      { name: "Simon", role: "Bass/Synths" },
      { name: "Phil", role: "Guitar/Vocals" },
      { name: "Ricky", role: "Drums" }
    ],
    soundcloud: "message-fromthe-oppressor",
    spotify: "6pgdlwfrpgm6fMuIOU44qg",
    bandcamp: "messagefromtheoppressor"
  },
  {
    id: "lapdogs",
    name: "Lapdogs",
    yearsActive: "2012",
    bio: "I briefly joined my friend Robbie's covers band, where I alternated guitar and bass with Karl. " +
      "It was a great setlist with quite a few older songs I hadn't played before - in particular Roxanne and Sweet Emotion.",
    albums: [
      {
        name: "Live Set",
        releaseDate: null,
        cover: null,
        tracks: [
          "20th Century Boy - T Rex",
          "Love Me Two Times - The Doors",
          "Plug In Baby - Muse",
          "Naked - Reef",
          "Everlong - Foo Fighters",
          "Waterfall - Stone Roses",
          "Black Hole Sun - Soundgarden",
          "Noone Knows - Queens of the Stone Age",
          "Lump - Presidents of the USA",
          "Whole Lotta Love - Led Zepellin",
          "Mr Brightside - The Killers",
          "Sweet Emotion - Aerosmith",
          "Scar Tissue - Red Hot Chilli Peppers",
          "Highway To Hell - ACDC",
          "Roxanne - The Police"
        ]
      }
    ],
    members: [
      { name: "Robbie", role: "Vocals" },
      { name: "Phil", role: "Guitar/Bass" },
      { name: "Karl", role: "Guitar/Bass" },
      { name: "Lochlann", role: "Drums" }
    ]
  },
  {
    id: "kowalskisko",
    name: "Kowalski's K.O.",
    yearsActive: "2009-2010",
    bio: "I joined this band after responding to a gumtree ad, and similar to the last band was continuing to play bass. I wanted to write my own material" +
      "on the side and felt palying bass would make it easier to seperate the two. These guys were great fun and we played a handful of gigs in North London." +
      "the first gig in particular was a real rush as I had only auditioned 4 days before and I was playing most the songs for the first time - and don't just mean live, " +
      "I mean first time playing them with band in any form as I had learned them from some recrordings the day before." +
      "In the end we split due to a mismatch in the level of commitment. Tim was missing more and more practices, while Dave was looking to create press packs" +
      " and set up a proper tour to try and get signed. Myself and Mark were somewhere in the middle of that so splitting up made sense sadly.",
    albums: [
      {
        name: "Live Set",
        releaseDate: null,
        cover: null,
        tracks: [
          "Bateman's Blues",
          "Die Frau B",
          "September",
          "Shoes",
          "The Gift",
          "Tidal Wave"
        ]
      }
    ],
    members: [
      { name: "Dave", role: "Vocals/Guitar" },
      { name: "Mark", role: "Guitar" },
      { name: "Phil", role: "Bass/Backing Vocals" },
      { name: "Tim", role: "Drums" }
    ]
  },
  {
    id: "electricrain",
    name: "Electric Rain",
    yearsActive: "2004-2005",
    bio: "The band were already established with a handful of Led Zepellin esc songs when I was introducted by a mutual friend. " +
      "I played bass for a change which was fun given the melodic bass lines they had written - again a Led Zep influence there. " +
      "We played only one gig then I had to leave as getting to practice once a week was taking me hours as they all lived in West London. " +
      "The final straw was getting my car towed one night while at practice and having to pick it up from a hidden depo under Hyde Park at 1am!",
    albums: [
      {
        name: "Live Set",
        releaseDate: null,
        cover: null,
        tracks: [
          "Afterlife"
        ],
        incomplete: true
      }
    ],
    members: [
      { name: "Steve", role: "Vocals/Guitar" },
      { name: "Rajit", role: "Guitar" },
      { name: "Phil", role: "Bass" },
      { name: "Steven", role: "Drums" }
    ]
  },
  {
    id:"deathbymonkeys",
    name: "Death By Monkeys",
    yearsActive: "2000",
    bio: "A covers band formed for only 1 gig - the Winter Halls Party at our Birmingham University halls. " +
    "Was really good fun, and we got free beer and pizza so totally worth it. Was a reunion of sorts for me and Chris from our Anarkise days. " +
    "James is one the best singers I've played with, channeling the range and stage presence of Jack Black! " +
    "The name comes from a line in Toy Story in case you are wondering",
    albums: [
        {name: "Live Set", releaseDate: null, cover: null,
            tracks:[
                "All The Small Things - Blink 182",
                "Are You Gonna Go My Way - Lenny Kravitz",
                "Pardon Me - Inclubus",
                "Under the Bridge - Red Hot Chili Peppers",
                "Wide Open Space - Mansun",
                "Place Your Hands - Reef",
                "Oh Yeah - Ash"
            ],
            incomplete:true
        }
    ],
    members: [
        {name: "James", role: "Vocals"},
        {name: "Phil", role: "Guitar"},
        {name: "Chris", role: "Bass"},
        {name: "Paul", role: "Drums"}
    ]
},
{
    id:"kit",
    name:"Kit",
    yearsActive:"1999-2000",
    bio:"I joined this band in my first year of University but in the end we didn't really do very much together. " +
    "We played in the local Battle of the Bands and I think we won a Performance award (that will have been thanks to Si and Anna), but disbanded soon after as half the band were in upper years and had to focus on studies.",
    albums: [],
    members:[
        {name:"Anna",role:"Vocals"},
        {name:"Si",role:"Guitar"},
        {name:"Phil",role:"Guitars"},
        {name:"Adam",role:"Bass"},
        {name:"Paul",role:"Drums"}
    ]
},
{
    id:"nakedboy",
    name:"Naked Boy",
    yearsActive:"1994-1999",
    profile:"nb-profile.jpg",
    bio:"This was the longest running and most serious band I've been in. " +
    "Having actually learnt to play our instruments by now, our friend Ricky stepped in as a permanent drummer and we renamed ourselves for this new era. As you can see from the list on this page, all my bands have terrible names, but this is by far the worst. " +
    "It was born of a more innocent time (we were only 15) and we just thought it would be funny to name the band after a nickname our guitarist got after a game of strip-spin the bottle. " +
    "The internet was in it's infancy too so we didn't realise that this name would be un-googlable. " +
    "We played 100s of gigs together, recorded in professional studios and even sign a development deal with small London record label." +
    "We played a number of support slots including one for The Godfathers who didn't turn up so we had to headline - much to the disappointment of thier fans!." +
    " We also came second in a competition to play at the now defunct Pheonix Festival which would have been huge.",
    albums: [

        {name:"Poor Me",releaseDate:"1/9/1998",cover:"/img/music/nb-poor_me.jpeg",
            tracks:[
                "Poor Me",
                "Living In This",
                "Drowners"
            ]},
        {name:"(in)Complete Works",releaseDate:null,cover:"/img/music/nb-complete.jpeg",
            tracks:[
                "Something Good",
                "Teenage Bisexual",
                "Easy",
                "Just Us",
                "Nightfall",
                "Another Day",
                "Anything You Say",
                "Amy",
                "Give Us A Clue",
                "Excerpt F",
                "Ozone (+ Danger Mouse)"
            ]},
        {name:"Live Only",releaseDate:null,cover:null,
            tracks:[
                "We Are Naked Boy",
                "Egyptian Song",
                "Freak",
                "Slow Motion",
                "Glow",
                "The Way You Seem to Notice",
                "Inside"
            ]},
        {name:"Covers",releaseDate:null,cover:null,
            tracks:[
                "Caught By The Fuzz - Supergrass",
                "Number One Pure Alchohol - 60ft Dolls",
                "Kung Fu - Ash",
                "I'll Stick Around - Foo Fighters",
                "Monkey Wrench - Foo Fighters",
                "Aneurysm - Nirvana",
                "Fell On BLack Days - Soundgarden",
                "Just - Radiohead",
                "Wanker - Bennet",
                "Richard III - Supergrass",
                "Tomorrow - Silverchair",
                "Deftones - My Own Summer (Shove It)"
            ]}
    ],
    members:[
        {name:"Phil",role:"Vocals/Guitars"},
        {name:"Aiden",role:"Guitars"},
        {name:"Ricky",role:"Drums"},
        {name:"James/Dan",role:"Bass"}
    ]
},
{
    id:"anarkise",
    name:"Anarkise",
    yearsActive:"1993",
    bio:"Yes you are reading that correctly. Three vocalists and only one guy with any musical ability playing all the instruments. " +
    "For all the early songs Aiden recorded backing tracks on his keyboard/drum machine then played lead guitar over the top." +
    "Myself and James did eventually buy guitars and learned to play guitar and bass repectively on the later songs, and we did recruit a drummer for the one gig we played." +
    "We were heavily inspired by Rage Against The Machine hence the early focus on riffs and 'rapping' (!?). We also wanted to be political like them" +
    " but being 14 in the early 90s with no internet it wasn't so easy to self-educate so most the lyrics became reduced to aggresive non-sensical rants about injustice." +
    "We also attended a Catholic school run by nuns so the shock factor of an anti-relgious rhetoric was also appealing. " +
    "Playing Time to Die to the nuns at the school talent show was a pretty bold move at our very conservative school, but to be fair they took it well. " +
    "We were the only live band to play, and if memory serves me well I'm pretty sure the act before us was someone quietly reading from a book for 30mins" +
    " - so going from that to 3 guys screaming Time To Die was perfect.",
    albums: [
        {name:"Execution of the Innocent",releaseDate:null,cover:null,
            tracks:[
                "Anteater",
                "Church On Fire",
                "Execution of the Innocent",
                "Face The Facts",
                "Quarantine",
                "Sandstorm",
                "Slavery",
                "Time To Die",
                "Wolves",
                "Chains In Their Minds",
                "Just Another Sucker"
            ]},
        {name:"Covers",releaseDate:null,cover:null,
            tracks:[
                "Killing In the Name Of - Rage Against The Machine"
            ]}
    ],
    members:[
        {name:"Phil",role:"Vocals"},
        {name:"James",role:"Vocals"},
        {name:"Chris",role:"Vocals"},
        {name:"Aiden",role:"Guitars/Keyboard/Drum Machine"}
    ]
}
]; 